<template>
    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex ">
                <section class="mu-d-flex mu-flex-row">
                    <h1>{{ title }}</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
            </div>

        </div>
        <div class="mcc-container mu-m-06">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>My processes</li>
                    <li>{{ title }}</li>
                    <li class="lastBredCrumpLi">

                    </li>
                </ol>
            </nav>

            <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitDialog" title="Process Filters">
               
               
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <form id="formIdd">

                                    <div class="mcc-segmented-buttons mcc-segmented-buttons--sm drawer-input">
                                        <fieldset class="mfc-fieldset">
                                            <legend class="mfc-label">
                                                Status
                                            </legend>
                                            <div class="mcc-segmented-buttons__list" label="Status" block ref="radioRef"
                                                name="status-radioGroup" id="status-radioGroup">
                                                <input type="checkbox" name="not-started" value="running"
                                                    id="not-started" @click="statusRef = $event.target.value"
                                                    :checked="statusRef == 'running'">
                                                <label class="mcc-segmented-buttons__button" for="not-started">
                                                    <span class="mcc-segmented-buttons__label">Running</span>
                                                </label>
                                                <input type="checkbox" name="pending" value="completed" id="pending"
                                                    @click="statusRef = $event.target.value"
                                                    :checked="statusRef == 'completed'">
                                                <label class="mcc-segmented-buttons__button" for="pending">
                                                    <span class="mcc-segmented-buttons__label">Completed</span>
                                                </label>
                                                <input type="checkbox" name="in-progress" value="all" id="in-progress"
                                                    @click="statusRef = $event.target.value"
                                                    :checked="statusRef == 'all'">
                                                <label class="mcc-segmented-buttons__button" for="in-progress">
                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div class="mfc-slim-select-wrapper drawer-input "
                                        id="InvolvingselectIdDiv">
                                        <label for="selectPage" class="mu-mb-00">Involving</label>
                                        <div id="InvolvingselectIdDiv"></div>
                                        <select ref="involvingRef" name="Involving-select" id="InvolvingselectId" block
                                            label="Involving"  @change="selectedInvolvingRef = $event.target.value">
                                            <option data-placeholder="true" value="" :selected="selectedInvolvingRef == ''"></option>
                                            <option v-for="(app, key) in userList"
                                                :selected="selectedInvolvingRef === app.username" :key="key"
                                                :value="app.username">{{ app.firstName }}</option>
                                        </select>
                                    </div>

                                    <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input ">
                                        <label for="changeDateId" class=" mb-0">Started between</label>
                                        <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text flatpickr-date--width flatpickrInstance"
                                            id="dateFromId">
                                            <input name="changeDate" id="changeDateId"
                                                ref="changeDate" icon="calendar" placeholder="Select Date.." data-input
                                                @change="handleStartRangeChange($event)"
                                                @ready="handleStartRangeReady()">
                                            <button type="button" class="mcc-button mcc-button--outline" data-toggle
                                                aria-label="date">
                                                <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                            </button>
                                            <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                <span>Please select proper dates.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input ">
                                        <label for="changeToDateId" class=" mb-0">Completed between</label>
                                        <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text flatpickr-date--width flatpickrInstances"
                                            id="dateToId">
                                            <input name="endDate" placeholder="Select Date.." id="endDateId" ref="endDate" data-input
                                                icon="calendar" @change="handleEndRangeChange($event)"
                                                @ready="handleEndRangeReady()">
                                            <button type="button" class="mcc-button mcc-button--outline" data-toggle
                                                aria-label="date">
                                                <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                            </button>
                                            <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                <span>Please select proper dates.</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                </div>

                            </div>
                        
               
            </Drawer>


            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row">
                <div class="mcc-col">
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="mcc-row">
                                        <div class="mcc-col ">
                                            <div class=" mu-pb-05 mu-radius-top">
                                                <div class="mfc-input-wrapper">
                                                    <div class="mfc-input-group mfc-input-group--leading-icon">
                                                        <mcc-icon class="mfc-input-group__icon mu-mt-02" name="search"
                                                            id="list-group-icon" aria-hidden="true"></mcc-icon>
                                                        <input id="list-group-filter" name="list-group-filter" ref="listGroupFilter"
                                                            type="text" placeholder="Type to search...">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-col mcc-col-auto">
                                            <button class="mcc-button mcc-button--outline"
                                                @click="$refs.customFilter.open()">
                                                <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' +
                        filterCount + ')' : '(1)' }}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact"
                                        v-if="showNoRecords">
                                        <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                                        <span>No processes found</span>
                                        <button @click="showNoRecords = !showNoRecords"
                                            class="mcc-button mcc-button--info mcc-button--sm mcc-button--icon-only"
                                            style="margin-inline-start: auto">
                                            <mcc-icon name="close" icon-set="fluency-outline"
                                                aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Button</span>
                                        </button>
                                    </mcc-alert>
                                    <ul class="mcc-list-group" v-show="showProcesses">
                                        <li v-for="(app, key) in processList" :key="key" class="mcc-list-group-li">

                                            <details class="mcc-collapse mu-w-100" @click="handleExpand(key)"
                                                :id="'collapseTasks' + key">
                                                <summary>
                                                    <div class="mcc-menu__button">
                                                        <mcc-icon class="mcc-icon--advanced mr-1"
                                                            v-if="app.iconSet == ''" :name="app.processLogo"></mcc-icon>
                                                        <mcc-icon class="mr-1" v-if="app.iconSet != ''"
                                                            :name="app.processLogo" icon-set="fluency-color"></mcc-icon>
                                                        {{ app.defName }}

                                                    </div>
                                                    <span class="mcc-chip mcc-chip--sm mcc-chip--info mu-mr-04">{{
                                                        app.numberOfProcesses}}</span>
                                                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow"
                                                        aria-hidden="true"></mcc-icon>
                                                </summary>
                                                <div class="mcc-collapse-body mu-mt-03">
                                                    <mcc-data-table ref="myTable" :id="'myTable'+key"></mcc-data-table>
                                                </div>
                                            </details>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";

import constantMessages from "../../messages";
import Table from "@advanced/component-mosaic-table";
import MyProcessListAPI from "../../services/MyProcessListAPI";
import Drawer from '../common/Drawer.vue';
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../formvalid.js';
export default {
    name: "MyProcessList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["myProcesses.startedByMe"],
            fetchCall: false,
            showProcesses: false,
            processList: [],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            searchCriteria: {},
            tableObj: [],
            userList: [],
            currentPageSize: [],
            pageType: "StartedByMe",
            involvingAll: false,
            title: "Started by me",
            statusRef: "running",
            statusType: "running",
            selectedInvolvingRef: "",
            selectedInvolving: "",
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            updateCall: false,
            showNoRecords: false,
            updateCallTable: false,
            processListLoaded: false,
            selectInstanceEntities: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
        };
    },
    created() {
        let self = this;
        this.pageType = this.$route.name;
        this.updatePageAppearance();
        this.selectInstanceEntities = new SlimSelect({
            select: '#InvolvingselectId',

        })
        this.flatPickr();

    },
    mounted() {
        let self = this;
        Utils.applyFixedHeaderConfiguration(this);

        if (localStorage.getItem(this.pageType.toLowerCase() + "Processes") == this.pageType.toLowerCase()) {
            var storedStatus = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_statusType"
            );;
            if (storedStatus != null && storedStatus != "") {
                this.statusRef = storedStatus;
                this.statusType = storedStatus;
            }
            var storedInvolving = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving"
            );
            if (storedInvolving != null && storedInvolving != "") {
                this.selectedInvolving = storedInvolving;
                this.selectedInvolvingRef = storedInvolving;
            }
            var startDateRangStringArr = localStorage
                .getItem(
                    "DataTables_" + window.location.pathname + "_startDateRangeRef"
                );

            if (startDateRangStringArr != null && startDateRangStringArr != "") {
                startDateRangStringArr = startDateRangStringArr.split(",");
                if (startDateRangStringArr.length > 1) {
                    this.startDateRangeRef[0] = new Date(startDateRangStringArr[0]);
                    this.startDateRangeRef[1] = new Date(startDateRangStringArr[1]);
                }
            }

            var endDateRangStringArr = localStorage
                .getItem("DataTables_" + window.location.pathname + "_endDateRangeRef");

            if (endDateRangStringArr != null && endDateRangStringArr != "") {
                endDateRangStringArr = endDateRangStringArr.split(",");
                if (endDateRangStringArr.length > 1) {
                    this.endDateRangeRef[0] = new Date(endDateRangStringArr[0]);
                    this.endDateRangeRef[1] = new Date(endDateRangStringArr[1]);
                }
            }
            this.updateDateRef();
            localStorage.removeItem(this.pageType + "Processes");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_statusType"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_endDateRangeRef"
            );
            this.filterCount = parseInt(
                localStorage.getItem("auditListFilterCount")
            );
            localStorage.removeItem("auditListFilterCount");
        }

        MyProcessListAPI.getUsers().then(result => {
            this.userList = result;
            this.fetchCall = true;
            this.showProcesses = true;

        });
        this.updateProcessData();
        this.selectInstanceEntities = new SlimSelect({
            select: '#InvolvingselectId',

        })
        this.flatPickr()
        const listGroupFilter = document.querySelector('input#list-group-filter')
        listGroupFilter.addEventListener('input', (event) => {
            this.filterItems(event)
        })
    },

    methods: {
        filterItems(event) {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)

            window.filterTimeout = setTimeout(() => {
                const filter = event.target.value.toLowerCase()
                const items = listGroupComponent.querySelectorAll('li')

                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
                items.forEach(item => {
                    if (!item.innerText.toLowerCase().includes(filter)) item.classList.add('mu-d-none')
                })
            }, 250)
        },

        removeFilterOnSubmit() {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)
            window.filterTimeout = setTimeout(() => {
                const items = listGroupComponent.querySelectorAll('li')
                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
            }, 250)
        },


        getFilterCount() {
            if (this.involvingAll != "")
                this.filterCount += 1
            if (this.statusType != "")
                this.filterCount += 1
            if (this.startedAfter != "")
                this.filterCount += 1
            if (this.finishedAfter != "")
                this.filterCount += 1
            if (this.selectedInvolving != "")
                this.filterCount += 1
        },

        resetSlimSelect() {
            this.selectInstanceEntities.setSelected('')

        },
        flatPickr() {
            let self = this;

            self.flatPickerInstance = flatpickr('.flatpickrInstance', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                wrap:true,
                mode: 'range',
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
                onChange: (selectedDates, dateStr) => {
            
                this.startDateRangeRef = dateStr ? dateStr.split(" to ") : [];
            },
            })

            self.flatPickerInstance = flatpickr('.flatpickrInstances', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                wrap:true,
                mode: 'range',
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],

            })

        },
        updateProcessData() {
            let self = this;
            var queryString = "involvingAll=" + self.involvingAll;
            if (!self.involvingAll) {
                queryString += "&currentUser=true";
            }
            self.showProcesses = false;
            self.showNoRecords = false;

            if (self.statusType == "running") {
                queryString += "&finished=false";
            } else if (self.statusType == "completed") {
                queryString += "&finished=true";
            }
            if (self.startedAfter != "") {
                queryString +=
                    "&startedAfter=" +
                    self.startedAfter +
                    "&startedBefore=" +
                    this.startedBefore;
            }
            if (self.finishedAfter != "") {
                queryString +=
                    "&finishedAfter=" +
                    self.finishedAfter +
                    "&finishedBefore=" +
                    self.finishedBefore;
            }
            if (self.selectedInvolving != "") {
                queryString += "&involvedUser=" + encodeURI(self.selectedInvolving);
            }

            MyProcessListAPI.getMyProcesses(queryString).then(result => {
                self.processList = result;
                self.processListLoaded = true;
                self.showProcesses = result.length > 0;
                if (result.length == 0) {
                    self.showNoRecords = true;
                } else {
                    for (let i = 0; i < self.processList.length; i++) {
                        if (self.processList[i].processLogo != null && self.processList[i].processLogo.indexOf(":") != -1) {
                            let procLogo = self.processList[i].processLogo.split(":");
                            self.processList[i].processLogo = procLogo[0];
                            self.processList[i].iconSet =
                                procLogo.length > 1 && procLogo[1] != "" ? "fluency-color" : "";
                        } else {
                            self.processList[i].processLogo = "process";
                            self.processList[i].iconSet = "";
                        }
                    }
                }
            });
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
            this.showDialog()
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value;
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value;
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        submitDialog(e) {
            let form = $('#formIdd')
            this.$refs.listGroupFilter.value = ''
            this.removeFilterOnSubmit()
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            this.statusType = this.statusRef;
            this.selectedInvolving = this.selectedInvolvingRef;
            this.tableObj = [];
            this.updateProcessData();
            $('.mcc-accordion').removeAttr("open")
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.$refs.filterDialog.close();
            this.updateCall = false;
        },
        resetFilter() {
            this.statusRef = "running";
            this.statusType = "running";
            this.selectedInvolving = "";
            this.filterCount = 0;
            this.selectedInvolvingRef = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = [];
            this.endDateRangeRef = [];
            this.resetSlimSelect();
            flatpickr("#dateFromId").destroy();
            flatpickr("#dateToId").destroy();
            this.flatPickr();
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.tableObj = [];
            this.updateProcessData();
        },
        showDialog() {
            this.updateCall = true;
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (this.startDateRangeRef.length > 0) {
                var startDateFrom = this.startDateRangeRef.split(" to ")[0];
                var startDateTo = this.startDateRangeRef.split(" to ")[1];
                var d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.startedAfter = d.toISOString();
                if (!startDateTo) {
                    startDateTo = startDateFrom
                }
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (self.endDateRangeRef.length > 0) {
                var endDateFrom = self.endDateRangeRef.split(" to ")[0];
                var endDateTo = self.endDateRangeRef.split(" to ")[1];
                var d = new Date(endDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.finishedAfter = d.toISOString();
                if (!endDateTo) {
                    endDateTo = endDateFrom
                }
                d = new Date(endDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = d.toISOString();
            }
        },
        updatePageAppearance() {
            if (this.pageType == "InvolvingMe") {
                this.title = "All involved";
                this.helpText =
                    constantMessages.BREADCRUMB_HELP["myProcesses.allInvolved"];
                this.involvingAll = true;
            }
        },
        handleExpand(key) {
            this.updateCallTable = true;
            this.initProcessesTable(key);
        },
        initProcessesTable(key) {
            var self = this;
            if (this.tableObj[key] == null) {
                self.updateCallTable = false;
                if (self.currentPageSize[key] == null) {
                    self.currentPageSize[key] = 10;
                }
                var prop = {
                    processDefinitionName: {
                        type: "string",
                        title: "Process",
                        template: '<a class="name-link" data-id="{{processInstanceId}}">{{processDefinitionName}}</a>',
                        sortable: false,
                        columnSearch: false
                    },
                    startUserId: {
                        type: "string",
                        title: "Started by",
                        sortable: false,
                        columnSearch: false
                    },
                    prettyStartTime: {
                        type: "string",
                        title: "Started",
                        template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{startTimeObject}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyEndTime: {
                        type: "string",
                        title: "Completed",
                        template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{endTimeObject}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyDurationInMillis: {
                        type: "string",
                        title: "Duration",
                        template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    }
                };
                if (!self.filterActive) {
                    if (
                        self.processList[key].selectedVariables != null &&
                        self.processList[key].selectedVariables.length > 0
                    ) {
                        var selectedVars = self.processList[key].selectedVariables;
                        for (var i = 0; i < selectedVars.length; i++) {
                            prop["a" + selectedVars[i]] = {
                                type: "string",
                                title: selectedVars[i],
                                sortable: false,
                                columnSearch: false
                            };
                        }
                    }
                }
                this.tableObj[key] = window.tableFactory.create(document.querySelector('#myTable' + key), {
                    bordered: true,
                    striped: true,
                    emptyTemplate: '<p class="text-center m-0">No processes found</p>',
                    loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                    columnSearch: false,
                    pageSize: self.currentPageSize[key],
                    debounceTime: 1000,
                    schema: {
                        properties: prop
                    },
                    data: (
                        start,
                        limit,
                        sortHeader,
                        sortDirection,
                        fullTextQuery,
                        searchColumns
                    ) => {
                        if (!self.filterActive) {
                            self.updateCallTable = false;
                            if (self.tableObj[key] != null) {
                                self.currentPageSize[key] =
                                    self.tableObj[key].tableContext.store.state.pageSize;
                            }
                            var sortHeaderData = sortHeader == null ? "" : sortHeader;
                            var sortDir = sortDirection == null ? "" : sortDirection;
                            if (sortHeaderData == "prettyStartTime") {
                                sortHeaderData = "startTime";
                            } else if (sortHeaderData == "prettyEndTime") {
                                sortHeaderData = "endTime";
                            } else if (sortHeaderData == "prettyDurationInMillis") {
                                sortHeaderData = "duration";
                            }
                            var queryString =
                                "start=" +
                                start +
                                "&length=" +
                                self.currentPageSize[key] +
                                "&sort=" +
                                sortHeaderData +
                                "&dir=" +
                                sortDir +
                                "&processDefinitionName=" +
                                self.processList[key].defName +
                                "&filterInput=true&involvingAll=" +
                                self.involvingAll;
                            if (!self.involvingAll) {
                                queryString += "&currentUser=true";
                            }

                            if (self.startedAfter != "") {
                                queryString +=
                                    "&startedAfter=" +
                                    self.startedAfter +
                                    "&startedBefore=" +
                                    this.startedBefore;
                            }
                            if (self.finishedAfter != "") {
                                queryString +=
                                    "&finishedAfter=" +
                                    self.finishedAfter +
                                    "&finishedBefore=" +
                                    self.finishedBefore;
                            }
                            if (self.statusType == "running") {
                                queryString = queryString + "&finished=false";
                            } else if (self.statusType == "completed") {
                                queryString = queryString + "&finished=true";
                            }
                            if (self.selectedInvolving != "") {
                                queryString += "&involvedUser=" + encodeURI(self.selectedInvolving);
                            }
                            return MyProcessListAPI.getProcessData(queryString, []).then(result => {
                                var responseData = {
                                    totalCount: 0,
                                    data: []
                                };
                                responseData.totalCount = result.recordsTotal;
                                if (result.data != null) {
                                    result.data.forEach(element => {
                                        if (
                                            self.processList[key].selectedVariables != null &&
                                            self.processList[key].selectedVariables.length > 0
                                        ) {
                                            var selectedVars = self.processList[key].selectedVariables;
                                            for (var i = 0; i < selectedVars.length; i++) {
                                                element["a" + selectedVars[i]] = "";
                                            }
                                        }
                                        if (element.customProcessVariables != null) {
                                            for (const property in element.customProcessVariables) {
                                                element["a" + property] =
                                                    element.customProcessVariables[property];
                                            }
                                        }

                                        element['startTimeObject'] = (element.startTimeInDate != null) ?
                                            Utils.getMomentDateString(element.startTimeInDate) : '';

                                        element['endTimeObject'] = (element.endTimeInDate != null) ?
                                            Utils.getMomentDateString(element.endTimeInDate) : '';

                                        element['durationInMillis'] = (element.durationInMillis != null) ?
                                            element.durationInMillis + ' ms' : '';

                                    });
                                    responseData.data = result.data;
                                    self.tableData = responseData.data;
                                }
                                self.updateCallTable = true;
                                return responseData;
                            });
                        } else {
                            self.filterActive = false;
                            let responseData = {
                                totalCount: self.filterData.length,
                                data: self.filterData
                            };
                            return responseData;
                        }
                    },
                    onAfterDataLoad: (start, limit) => {
                        self.updateTemplate(key);
                    }
                });
            }
        },
        updateTemplate(key) {
            let self = this;
            this.$refs.myTable[key]
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var procInstId = $(targetEle).attr("data-id");
                            self.setFilterDataInLocalStorage();
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/processes/processinstance/" + procInstId.trim() + "/" + self.pageType.toLowerCase()
                            );
                        }
                    });
                });
        },
        updateOrderList(filteredOrderList) {
            this.filterData = filteredOrderList;
            this.filterActive = true;
            this.initProcessesTable();

        },
        filterFunctionList(filteredRows, filterValue) {
            return filteredRows.filter(function (r) {
                return (
                    (r.processDefinitionName && r.processDefinitionName.toLowerCase().includes(filterValue.toLowerCase())) ||
                    (r.startUserId && r.startUserId.toLowerCase().includes(filterValue.toLowerCase()))

                );
            })
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_statusType",
                this.statusType
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving",
                this.selectedInvolving
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef",
                this.startDateRangeRef
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_endDateRangeRef",
                this.endDateRangeRef
            );
            localStorage.setItem("auditListFilterCount", this.filterCount);
        }
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}


.mcc-list-group-li {
    border-bottom: 1px solid #666679;
}

.mcc-list-group {
    border-top: 1px solid #666679;
    border-left: 1px solid #666679;
    border-right: 1px solid #666679;
}
</style>
